import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchInterviewData, fetchNewApplicants, handleCurrentPage, setSearch } from "../../../redux/slices/newApplicantsSlice"; // Import the thunk action
import { CERTIFICATE_STATUS_LABELS_VALUES, CERTIFICATE_TYPES_TABS, TIMESLOTOPTIONS } from "../../../data/NewApplicantsConstants";
import Pagination from "../../../components/Pagination";
import Filter from "../../../components/Filter";
import { handleCertificateType } from "../../../redux/slices/tablesSlice";
import { formatDateForDisplay } from "../../../utils/HelperFunctions";
// import "../../../styles/TabLayout.css";
import "./Interview.css"
const IntervieweData = () => {
    const [data, setData] = useState([]);
    const report_type = 7;
    const dispatch = useDispatch();
    const start_date = useSelector((state) => state.newApplicants.startDate);
    const end_date = useSelector((state) => state.newApplicants.endDate);
    const { current_page, total_pages, loading, error } = useSelector((state) => state.newApplicants.data);
    const [showModal, setShowModal] = useState(false);
    const modalRef = useRef();
    const activeTypeTab = useSelector((state) => state.newApplicants.certificateType);
    const [initialValues, setInitialValues] = useState({
        full_name: "",
        interview_date: "",
        technology_field: "",
        identity_number: "",
    });
    const fetchInterview = () => {
        const payload = {
            page: current_page,
            limit: 10, // Set your desired limit here
            start_date: start_date ? moment(start_date).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null,
            end_date: end_date ? moment(end_date).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null,
            certificate_type: activeTypeTab,
            full_name: null,
            interview_date: null,
            technology_field: null,
            identity_number: null,
            search: null,
        };

        dispatch(fetchInterviewData(payload)).then((response) => {
            setData(response?.payload?.interviews);
        }); // Dispatch the thunk action
    }
    useEffect(() => {
        fetchInterview();
    }, [current_page, start_date, end_date, dispatch, activeTypeTab]);
    const handlePagination = async (page) => {
        dispatch(handleCurrentPage(page));
    };

    const getValueOrDefault = (value) => (value ? value : "-");

    const getTimeSlotLabel = (slotNumber) => {
        const slotLabel = Object.keys(TIMESLOTOPTIONS).find(key => TIMESLOTOPTIONS[key] === slotNumber);
        return slotLabel ? slotLabel : "-";
    };
    const openModal = () => {
        setShowModal(true);
        document.body.style.overflow = "hidden";
    };
    // Helper function to get label based on status value
    const getStatusValueOrDefault = (status) => {
        const statusEntry = CERTIFICATE_STATUS_LABELS_VALUES.find((item) => item.value === status);
        return statusEntry ? statusEntry.label : "Unknown Status";
    }

    const closeModal = () => {
        setShowModal(false);
        document.body.style.overflow = "auto";
    };
    const handleFilter = (values) => {
        // fetchData(values);
        dispatch(
            fetchInterviewData({
                page: 1,
                limit: 10,
                start_date: start_date,
                certificate_type: activeTypeTab,
                end_date: end_date,
                full_name: values?.full_name,
                interview_date: values?.interview_date,
                technology_field: values?.technology_field,
                identity_number: values?.identity_number,
                search: values?.search,
                // status: status,
            })
        ).then((response) => {
            setData(response?.payload?.interviews);
            setInitialValues({
                full_name: values?.full_name || "",
                technology_field: values?.technology_field || "",
                identity_number: values?.identity_number || "",
                interview_date: values?.interview_date || "",
                search: values?.search || "",
            });
        });
    };
    const handleSearch = (val) => {
        dispatch(setSearch(val));
    };

    return (
        <div className="TabLayout p-3">
            <nav>
                <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                    {/* Certificate type tabs */}
                    <div className="d-flex stage2 justify-content-evenly px-3" style={{ gap: "40px", width: "100%" }}>
                        {CERTIFICATE_TYPES_TABS
                            .filter((type) =>
                                type.name === "All" ||
                                type.name === "Professional Technologist" ||
                                type.name === "Certified Technician"
                            )
                            .map((type) => (
                                <button
                                    key={type?.type}
                                    className={`nav-link border-0 ${activeTypeTab === type?.type && "active"}`}
                                    id={type?.type}
                                    onClick={() => dispatch(handleCertificateType(type?.type))}
                                >
                                    <p className="text-nowrap">{type?.name}</p>
                                </button>
                            ))}
                    </div>

                </div>
            </nav>
            <Filter
                openModal={openModal}
                closeModal={closeModal}
                modalRef={modalRef}
                showModal={showModal}
                handleFilter={handleFilter}
                initialValues={initialValues}
                setInitialValues={setInitialValues}
                handleSearch={handleSearch}
                fetchInterview={fetchInterview}
                fieldsToDisplay={{
                    full_name: true,
                    interview_date: true,
                    technology_field: true,
                    identity_number: true,
                }}
            />
            <div className="tab-content" id="nav-tabContent">
                <div className={`tab-pane fade show active`} role="tabpanel" aria-labelledby="nav-home-tab">
                    <div className="tabdiv">
                        {loading ? (
                            <div className="text-center">Loading...</div>
                        ) : error ? (
                            <div className="text-center text-danger">{error}</div>
                        ) : (
                            <div className="overflow-x-auto">
                                <table className="table_layout table-responsive">
                                    <thead>
                                        <tr className="text-nowrap">
                                            <th>No</th>
                                            <th>Full name</th>
                                            <th>IC/Passport No</th>
                                            <th>Interview Date</th>
                                            <th>Slot Time</th>
                                            <th>Skype ID</th>
                                            <th>Panelist</th>
                                            <th>Secretariat</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <div className="bordertop"></div>
                                    <tbody>
                                        {data?.length === 0 ? (
                                            <tr>
                                                <td colSpan={8} className="text-decoration-none text-center">
                                                    No Data Available
                                                </td>
                                            </tr>
                                        ) : (
                                            data?.map((ele, index) => (
                                                <tr key={ele.id}>
                                                    <td>{index + 1}</td>
                                                    <td className="text-uppercase">{getValueOrDefault(ele?.applicants?.user?.profile?.name)}</td>
                                                    <td>{getValueOrDefault(ele?.applicants?.user?.profile?.identity_number)}</td>
                                                    <td>{formatDateForDisplay(ele?.applicants?.date, "DD-MM-YYYY")}</td>
                                                    <td>{getTimeSlotLabel(ele?.applicants?.slot)}</td>
                                                    <td>{getValueOrDefault(ele?.applicants?.skype_id)}</td>
                                                    <td style={{ minWidth: "200px" }}>
                                                        {ele?.applicants?.panelists?.map((panelist, index) => (
                                                            <div key={index}>{index + 1}) {panelist}</div>
                                                        )) || "-"}
                                                    </td>

                                                    <td>{getValueOrDefault(ele?.applicants?.secretariat)}</td>
                                                    <td>{getStatusValueOrDefault(ele?.status)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                    {data.length > 0 && (
                        <Pagination
                            currentPage={current_page}
                            totalPages={total_pages}
                            setCurrentPage={handlePagination}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default IntervieweData;
